export const TAB_LIST_SIZES = ['default', 'sm'];

export const TAB_LIST_SIZE_MODIFIERS = {
  sm: 'd-tablist--sm',
};

export const TAB_LIST_KIND_MODIFIERS = {
  inverted: 'd-tablist--inverted',
};

export const TAB_LIST_IMPORTANCE_MODIFIERS = {
  borderless: 'd-tablist--no-border',
};

export const TAB_IMPORTANCE_MODIFIERS = {
  selected: 'd-tab--selected',
};
